import CardTableCell from './CardTableCell';
export default CardTableCell;
